import { useQuery } from '@tanstack/react-query'
import { spacesApi } from '@/api/spacesApi/spacesAPIclient'

export const useUnreadSpaceActivities = (
  spaceId?: string,
  options: { staleTime?: number } = {},
) => {
  const { staleTime = 1000 * 60 } = options
  return useQuery({
    queryKey: ['unreadSpaceActivities', spaceId],
    queryFn: async () => {
      if (!spaceId) return { unreadActivitiesCount: 0 }
      const response = await spacesApi.get(`/activity/own-unread-count?spaceId=${spaceId}`)
      return response.data
    },
    enabled: !!spaceId,
    staleTime,
  })
}
